import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWiiComponent } from './simple-icons-wii.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWiiComponent ],
    exports:      [ SimpleIconsWiiComponent ],
    bootstrap:    []
})
export class SimpleIconsWiiModule {}
